<template>
  <div class="page__list">
    <search-bar
      @search="onSearch"
      name="me_title,me_mrname"
      placeholder="输入会议议题、会议地点进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/oa/meeting/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.me_code}}</p>
          <p class="list-item-muted"><span v-format="'yyyy-MM-dd'">{{item.me_date}}</span> {{ item.me_start }}~{{ item.me_over }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.me_title}}</p>
          <span> {{item.me_mrname}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}条</label>
    </div>
    <add-button to="/oa/meeting_edit" icon="iconfont icon-add"/>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/oa/meeting/list",
      filters: [
        {
          type: "date",
          name: "me_date"
        },
      ]
    };
  },
  methods:{
    search(){
      this.onSearch()
    },
    
  }
};
</script>